import React, { Component } from 'react';
import RangeTouch from 'rangetouch';
import colors from './VolumeControl.scss';
import helpers from '../../helpers';

class VolumeControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            volume: process.env.REACT_APP_DEFAULT_VOLUME
        };
        this.sheet = document.createElement('style');
        this.prefs = [
            'webkit-slider-runnable-track',
            'moz-range-track',
            'ms-track'
        ];
    }

    componentDidMount() {
        const volumeControlElm = document.getElementById('volume');
        new RangeTouch(volumeControlElm, { addCSS: false }); // eslint-disable-line
        window.addEventListener('changeTheme', this.update.bind(this));
        this.update();
    }

    componentWillUnmount() {
        window.removeEventListener('changeTheme', this.update.bind(this));
    }

    getTrackStyle = currentValue => {
        const miniplayerObj = helpers.getMiniplayer(this, 0);
        const trackColor = colors[`${miniplayerObj.getTheme()}-trackColor`];
        const trackLowerFill =
            colors[`${miniplayerObj.getTheme()}-trackLowerFill`];
        const trackLowerFillGradient = colors[
            `${miniplayerObj.getTheme()}-trackLowerFillGradient`
        ]
            ? colors[`${miniplayerObj.getTheme()}-trackLowerFillGradient`]
            : trackLowerFill;

        return helpers.getTrackStyleCSS(this.prefs, {
            trackLowerFill,
            trackLowerFillGradient,
            trackColor,
            currentValue
        });
    };

    changeVolume = e => {
        this.setState({ volume: e.target.value });
        const player = window.NpoPlayer;

        if (player && player.setVolume) {
            player.setVolume(parseInt(e.target.value, 10) / 100);
        }
        this.sheet.textContent = this.getTrackStyle(e.target.value);
    };

    update() {
        this.sheet.textContent = this.getTrackStyle(
            document.getElementById('volume').value
        );
    }

    render() {
        document.body.appendChild(this.sheet);
        const { volume } = this.state;
        return (
            <div className="VolumeControl">
                <input
                    type="range"
                    id="volume"
                    min="0"
                    max="100"
                    step="1"
                    value={volume}
                    onChange={this.changeVolume}
                    onInput={this.changeVolume}
                    onTouchMove={this.changeVolume}
                    onTouchStart={this.changeVolume}
                    aria-label="Volume"
                />
            </div>
        );
    }
}

export default VolumeControl;
